'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

/**
 * Given an array of toasts for a specific position.
 * It returns the toast that matches the `id` passed
 */
var findById = function findById(arr, id) {
  return arr.find(function (toast) {
    return toast.id === id;
  });
};

/**
 * Given the toast manager state, finds the toast that matches
 * the id and return its position and index
 */
function findToast(toasts, id) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  var position = getToastPosition(toasts, id);
  var index = position ? toasts[position].findIndex(function (toast) {
    return toast.id === id;
  }) : -1;
  return {
    position: position,
    index: index
  };
}

/**
 * Given the toast manager state, finds the position of the toast that
 * matches the `id`
 */
function getToastPosition(toasts, id) {
  for (var _i = 0, _Object$entries = Object.entries(toasts); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray__default["default"](_Object$entries[_i], 2),
      position = _Object$entries$_i[0],
      values = _Object$entries$_i[1];
    if (findById(values, id)) {
      return position;
    }
  }
}

/**
 * Gets the styles to be applied to a toast's container
 * based on its position in the manager
 */
function getToastStyle(position) {
  var isRighty = position.includes('right');
  var isLefty = position.includes('left');
  var alignItems = 'center';
  if (isRighty) alignItems = 'flex-end';
  if (isLefty) alignItems = 'flex-start';
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignItems
  };
}

/**
 * Compute the style of a toast based on its position
 */
function getToastListStyle(position) {
  var isTopOrBottom = position === 'top' || position === 'bottom';
  var margin = isTopOrBottom ? '0 auto' : undefined;
  var top = position.includes('top') ? 'env(safe-area-inset-top, 0px)' : undefined;
  var bottom = position.includes('bottom') ? 'env(safe-area-inset-bottom, 0px)' : undefined;
  var right = !position.includes('left') ? 'env(safe-area-inset-right, 0px)' : undefined;
  var left = !position.includes('right') ? 'env(safe-area-inset-left, 0px)' : undefined;
  return {
    position: 'fixed',
    // Chakra overwrite: removed func for z-index value
    zIndex: '5500',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    margin: margin,
    top: top,
    bottom: bottom,
    right: right,
    left: left
  };
}
exports.findById = findById;
exports.findToast = findToast;
exports.getToastListStyle = getToastListStyle;
exports.getToastPosition = getToastPosition;
exports.getToastStyle = getToastStyle;